<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56 56"
  >
    <path
      d="M29.46 0V11.04C33.02 11.35 36.27 12.76 38.86 14.94L46.66 7.14C42.06 2.99 36.06 0.35 29.46 0Z"
      fill="currentColor"
    />
    <path
      d="M40.9805 17.0502C43.1505 19.6402 44.5705 22.8902 44.8805 26.4502H55.9205C55.5705 19.8502 52.9305 13.8502 48.7905 9.24023L40.9905 17.0402L40.9805 17.0502Z"
      fill="currentColor"
    />
    <path
      d="M44.8805 29.4592C44.5705 33.0192 43.1605 36.2692 40.9805 38.8592L48.7805 46.6592C52.9205 42.0492 55.5605 36.0492 55.9105 29.4492H44.8705L44.8805 29.4592Z"
      fill="currentColor"
    />
    <path
      d="M38.86 40.9805C36.27 43.1505 33.02 44.5705 29.46 44.8805V55.9205C36.06 55.5705 42.06 52.9305 46.67 48.7905L38.87 40.9905L38.86 40.9805Z"
      fill="currentColor"
    />
    <path
      d="M26.4598 44.8805C22.8998 44.5705 19.6498 43.1605 17.0598 40.9805L9.25977 48.7805C13.8698 52.9205 19.8698 55.5605 26.4698 55.9105V44.8705L26.4598 44.8805Z"
      fill="currentColor"
    />
    <path
      d="M14.93 38.8609C12.76 36.2709 11.34 33.0209 11.03 29.4609H0C0.35 36.0609 2.99 42.0609 7.13 46.6709L14.93 38.8709V38.8609Z"
      fill="currentColor"
    />
    <path
      d="M11.04 26.4598C11.35 22.8998 12.76 19.6498 14.94 17.0598L7.14 9.25977C2.99 13.8598 0.35 19.8598 0 26.4598H11.04Z"
      fill="currentColor"
    />
    <path
      d="M17.0502 14.93C19.6402 12.76 22.8902 11.34 26.4502 11.03V0C19.8502 0.35 13.8502 2.99 9.24023 7.13L17.0402 14.93H17.0502Z"
      fill="currentColor"
    />
  </svg>
</template>
